import axios from 'axios'

/**
 * Service for managing cluster data with the API
 * @namespace AreaClusterService
 */
const AreaClusterService = {
  /**
   * Retrieve data based on the provided parameters
   * @async
   * @param {Object} params - Query parameters to filter data
   * @param {number} params.page - Name of the area to search for
   * @param {number} params.per_page - Number of data per page
   * @param {string} params.sort - Sort by field (e.g., 'name', 'created_at')
   * @param {boolean} params.sort_desc - Sorting if descending (e.g., 'true' or 'false')
   * @param {string} params.filter_text - Text to filter data by name
   * @returns {Promise<Object>} The API response containing data
   */
  async get (params = {}) {
    return axios.get('admin/area-clusters', { params })
  },

  /**
   * Create a new cluster
   * @async
   * @param {Object} params - The cluster data to be created
   * @returns {Promise<Object>} The API response containing the created cluster
   */
  async post (params = {}) {
    return axios.post('admin/area-clusters', params)
  },

  /**
   * Update an existing cluster
   * @async
   * @param {Object} params - The cluster data to be updated
   * @param {string|number} params.id - The ID of the cluster to be updated
   * @returns {Promise<Object>} The API response containing the updated cluster
   */
  async put (params = { id: '' }) {
    return axios.put(`admin/area-clusters/${params.id}`, params)
  },

  /**
   * Delete an cluster by ID
   * @async
   * @param {Object} data - The data containing ID of cluster to delete
   * @param {string|number} data.id - The ID of the cluster to be deleted
   * @returns {Promise<Object>} The API response after deletion
   */
  async delete (data = { id: '' }) {
    return axios.delete(`admin/area-clusters/${data.id}`, { data })
  }
}

export default AreaClusterService
